import { rest } from 'msw'

const COGNITO_BASE_URL =
  typeof window === 'undefined'
    ? process
      ? process.env.COGNITO_BASE_URL
      : ''
    : window.COGNITO_BASE_URL

if (typeof COGNITO_BASE_URL !== 'string') {
  throw new Error('COGNITO_BASE_URL is not defined')
}

const url = new URL(COGNITO_BASE_URL)
url.pathname += 'oauth2/authorize'

export const success = rest.get(url.toString(), async (req, res, ctx) => {
  const url = new URL(req.url)

  const redirectUrl = new URL(url.searchParams.get('redirect_uri') || '')
  const state = url.searchParams.get('state') || ''
  redirectUrl.searchParams.set('state', state)
  redirectUrl.searchParams.set('code', 'success')

  return res(ctx.status(302), ctx.set('Location', redirectUrl.toString()))
})

export const cognitoConnectionError = rest.get(
  url.toString(),
  async (req, res, ctx) => {
    const url = new URL(req.url)

    const redirectUrl = new URL(url.searchParams.get('redirect_uri') || '')
    const state = url.searchParams.get('state') || ''
    redirectUrl.searchParams.set('error_description', 'invalid_scope')
    redirectUrl.searchParams.set('state', state)

    // Cognito does not send code when there is an error,
    // but not setting code in this mock **magically**
    // makes tests fail on CI. So, we set it to something.
    redirectUrl.searchParams.set('code', 'cognito_error_code')

    return res(ctx.status(302), ctx.set('Location', redirectUrl.toString()))
  },
)

export const cognitoGetTokenError = rest.get(
  url.toString(),
  async (req, res, ctx) => {
    const reqUrl = new URL(req.url)

    const redirectUrl = new URL(reqUrl.searchParams.get('redirect_uri') || '')
    const state = reqUrl.searchParams.get('state') || ''
    redirectUrl.searchParams.set('state', state)
    redirectUrl.searchParams.set('code', 'invalid_code')

    return res(ctx.status(302), ctx.set('Location', redirectUrl.toString()))
  },
)

export const generateInvalidAccessToken = rest.get(
  url.toString(),
  async (req, res, ctx) => {
    const reqUrl = new URL(req.url)

    const redirectUrl = new URL(reqUrl.searchParams.get('redirect_uri') || '')
    const state = reqUrl.searchParams.get('state') || ''
    redirectUrl.searchParams.set('state', state)
    redirectUrl.searchParams.set('code', 'invalid_access_token')

    return res(ctx.status(302), ctx.set('Location', redirectUrl.toString()))
  },
)

export default success
